import { Modal, ModalProps } from 'react-bootstrap-v5';
import { KTSVG } from 'src/_metronic/helpers';

interface IProps extends ModalProps {
  message: string;
  show: boolean;
  handleClose: () => void;
}
const IPErrorModal: React.FC<IProps> = ({message, show, handleClose, ...props}) => {

  return (
    <Modal className={`modal fade h-100 `} size={'sm'} show={show} onHide={handleClose}  {...props}>
      <div className="modal-content">
        {/* <div className="modal-header border-0 py-2">
          <div></div>
          <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" onClick={props.handleClose}>
            <KTSVG path="/media/icons/duotone/Navigation/Close.svg" className="svg-icon-2x" />
          </div>
        </div> */}
        <div className="modal-body text-center d-flex flex-column align-items-center">
          <KTSVG path="/media/icons/duotone/Alerts/alert-circle.svg" className="svg-icon-5x text-danger mb-5" />
          <p className="text-break">{message}</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary w-100" onClick={handleClose}>
            Kapat
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default IPErrorModal;
